import React from "react";
import { useLoaderData } from "react-router";

import BookingModal from "./components/BookingModal";
import Filters from "./components/Filters";
import FiltersSubRow from "./components/FiltersSubRow";
import GamesTable from "./components/GamesTable";
import { BookingModalProvider } from "./contexts/Modals";
import { FiltersProvider } from "./contexts/Filters";
import { GamesProvider, useGamesContext } from "./contexts/Games";

import { store } from "../../..";
import "../../../assets/css/umphub/pages/admin.scss";
import Pagination from "../../../components/Pagination";
import { PaginationProvider } from "../../../contexts/Pagination";
import {
    globalActions,
    selectSetting,
    selectSite,
} from "../../../features/global/globalSlice";
import { useAppSelector } from "../../../hooks/reduxHooks";
import { getGamesBySite } from "../../../lib/api";
import { IGame } from "../../../types/api";
import { UmpirePay } from "../../../types/shared";

export const loader = async ({ site }: any) => {
    const { settings, sites, umpires, fields } = store.getState().global;
    const promises = [];
    !settings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));
    !sites.length && promises.push(store.dispatch(globalActions.getSites()));
    !umpires.length &&
        promises.push(store.dispatch(globalActions.getUmpires()));
    !fields.length && promises.push(store.dispatch(globalActions.getFields()));

    const [{ games }] = await Promise.all([
        getGamesBySite(site, true),
        promises,
    ]);

    return {
        site,
        games,
    };
};

const CurrentYear = (): React.JSX.Element => {
    const { site: siteId, games } = useLoaderData() as {
        site: number;
        games: IGame[];
    };

    const site = useAppSelector(state => selectSite(state, siteId));
    const umpirePay = useAppSelector(state =>
        selectSetting(state, `${site?.settingPrefix}umpire_pay`),
    )?.setting as UmpirePay[];

    return (
        <FiltersProvider initialGames={games}>
            <Filters />

            <PaginationProvider>
                <GamesProvider
                    initialGames={games}
                    umpirePay={umpirePay}
                    site={siteId}
                >
                    <BookingModalProvider>
                        <FiltersSubRow />
                        <GamesTable />
                        <BookingModal />
                    </BookingModalProvider>
                    <Pagination useContext={useGamesContext} />
                </GamesProvider>
            </PaginationProvider>
        </FiltersProvider>
    );
};

export default CurrentYear;
